import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76116608"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "app-chrome"
}
const _hoisted_2 = { class: "app-content my-2 pt-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WHeader = _resolveComponent("WHeader")!
  const _component_WSystemStatusBar = _resolveComponent("WSystemStatusBar")!
  const _component_PScrollTop = _resolveComponent("PScrollTop")!
  const _component_RouterView = _resolveComponent("RouterView")!
  const _component_PToast = _resolveComponent("PToast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showChrome)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_WHeader),
          _createVNode(_component_WSystemStatusBar)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_PScrollTop, { size: "small" }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_RouterView, { class: "text-sm" })
    ]),
    _createVNode(_component_PToast, { position: _ctx.toastPosition }, null, 8, ["position"])
  ], 64))
}